export default {
  title: 'Información de pago verificada',
  description: 'Tu información de pago se ha verificado correctamente.',
};
